import config from '../config/config';
import api from '../config/apiConfig';
import util from './util';
import httpUtil from './httpUtil';
import skspjob from "./skspjob";
import sdnJob from './sdnJob';

// 基本业务实现
let job = {};

// 删除
job.delFun = function (vm,url, rt) {
    var msg = '是否确认删除？';
    var rtMsg = '删除成功';
    layui.use('layer', function () {
        layer.confirm(msg, {
            offset: config.layer.confirm.top
        }, function () {
            httpUtil.ajaxDelete(vm,url,
                function (response) {
                    util.success(rtMsg);
                    rt(response);
                });
        });
    });
};

// 新增
job.addFun = function (vm,url, params, suc, err) {
    var rtMsg = '保存成功';
    httpUtil.ajaxPost(vm,url, params,
        function (response) {
            util.success(rtMsg);
            suc(response);
        }, err);
};

// 保存
job.editFun = function (vm,url, params, suc, err) {
    var rtMsg = '保存成功';
    httpUtil.ajaxPut(vm,url, params,
        function (response) {
            util.success(rtMsg);
            suc(response);
        }, err);
};

// 表单提交
job.submitFormData = function (vm,url, params, suc, err) {
    var rtMsg = '保存成功';
    httpUtil.ajaxPostFile(vm,url, params,
        function (response) {
            util.success(rtMsg);
            suc(response);
        }, err);
};
// 表单提交
job.submitFormDataPut = function (vm,url, params, suc, err) {
    var rtMsg = '保存成功';
    httpUtil.ajaxPutFile(vm,url, params,
        function (response) {
            util.success(rtMsg);
            suc(response);
        }, err);
};


// 获取配置
job.getConfig = function (vm, type, suc) {
    var url = api.config.type + '/' + type;
    httpUtil.ajaxGet(vm, url, {},
        function (response) {
            var res = [];
            response.data.data.forEach(element => {
                var temp = {
                    codeVal: element.configVal,
                    codeName: element.configName,
                    content1: element.configCont1,
                    content2: element.configCont2,
                }
                res.push(temp);
            });
            suc(res);
        });
};

job.listAllParams = {
    pageNum: 0,
    pageSize: 99,
};

// 用户列表
job.getUserList = function (vm) {
    let res = [];
    httpUtil.ajaxGet(vm, api.user.list, job.listAllParams, function (response) {
        response.data.data.content.forEach(item => {
            res.push({
                userId: item.userId,
                userName: item.userName,
            });
        });
    });
    return res;
};

// 根据部门获取用户列表
job.getUserListByDeptId = function(vm,id,suc){
    let res = [];
    var url = api.user.findbydept + id;
    httpUtil.ajaxGet(vm,url , {}, function (response) {
        response.data.data.forEach(item => {
            res.push({
                userId: item.userId,
                userName: item.userName,
            });
        });
        suc(res);
    });
}
// 公司列表
job.getCorpList = function (vm) {
    let res = [];
    httpUtil.ajaxGet(vm, api.corp.list, job.listAllParams, function (response) {
        response.data.data.content.forEach(item => {
            res.push({
                corpName: item.corpName,
                corpNo: item.corpNo,
                corpId: item.corpId,
            });
        });
    });
    return res;
};

// 角色列表
job.getRoleList = function (vm) {
    let res = [];
    httpUtil.ajaxGet(vm, api.role.list, job.listAllParams, function (response) {
        response.data.data.content.forEach(item => {
            res.push({
                roleName: item.roleName,
                roleId: item.roleId,
            });
        });
    });
    return res;
}

// 菜单列表
job.getMenuList = function (vm) {
    let res = [];
    httpUtil.ajaxGet(vm, api.menu.list, job.listAllParams, function (response) {
        return  response.data.data.content;
    });
}

// 部门列表
job.getDeptList = function (vm) {
    let res = [];
    httpUtil.ajaxGet(vm, api.dept.list, job.listAllParams, function (response) {
        response.data.data.content.forEach(item => {
            res.push({
                deptName: item.deptName,
                deptNo: item.deptNo,
                deptId: item.deptId,
            });
        });
    });
    return res;
}

// 工厂列表
job.getPlantList = function (vm) {
    let res = [];
    httpUtil.ajaxGet(vm, api.plant.list, job.listAllParams, function (response) {
        response.data.data.content.forEach(item => {
            res.push({
                plantName: item.plantName,
                plantNo: item.plantNo,
                plantId: item.plantId,
            });
        });
    });
    return res;
}

// 工厂列表
job.getPlantListFunc = function (vm,suc) {
    let res = [];
    httpUtil.ajaxGet(vm, api.plant.list, job.listAllParams, function (response) {
        response.data.data.content.forEach(item => {
            res.push({
                plantName: item.plantName,
                plantNo: item.plantNo,
                plantId: item.plantId,
            });
        });
        suc(res);
    });
    return res;
}

// 根据工厂获取部门列表
job.getDeptListByPlantId = function(vm,id,suc){
    let res = [];
    var url = api.dept.findbyplant + id;
    httpUtil.ajaxGet(vm,url , {}, function (response) {
        response.data.data.forEach(item => {
            res.push({
                deptName: item.deptName,
                deptNo: item.deptNo,
                deptId: item.deptId,
            });
        });
        suc(res);
    });
    return res;
}

// 获取信号灯配置
job.getSignalSettingObj = function(vm){
    let res = {};
    var url =  api.sysSetting.type +'/'+ config.cfgType.statusType;
    httpUtil.ajaxGet(vm,url , {}, function (response) {
        var data = response.data.data;
        var list = JSON.parse(data.configVal);
        list.forEach(item=>{
            const obj = {
                statusType:item.key,
                statusTypeNm:item.title,
                statusColor:item.color,
            };
            res[obj.statusType] = obj;
        })
    });
    return res;
}

// 获取信号灯配置
job.getSignalSettingList = function(vm){
    let res = [];
    var url =  api.sysSetting.type +'/'+ config.cfgType.statusType;
    httpUtil.ajaxGet(vm,url , {}, function (response) {
        var data = response.data.data;
        var list = JSON.parse(data.configVal);
        list.forEach(item=>{
            const obj = {
                statusType:item.key,
                statusTypeNm:item.title,
                statusColor:item.color,
            };
            res.push(obj);
        })
    });
    return res;
}


// 工序列表
job.getProcessList = function (vm) {
    let res = [];
    httpUtil.ajaxGet(vm, api.process.list, job.listAllParams, function (response) {
        response.data.data.content.forEach(item => {
            res.push({
                processId: item.processId,
                processName: item.processName,
            });
        });
    });
    return res;
}

// 根据部门获取工序列表
job.getProcessListByDeptId = function(vm,id,suc){
    let res = [];
    var url = api.process.findbydept + id;
    httpUtil.ajaxGet(vm,url , {}, function (response) {
        response.data.data.forEach(item => {
            res.push({
                processId: item.processId,
                processName: item.processName,
            });
        });
        suc(res);
    });
    return res;
}

// 信号灯列表
job.getSignalList = function (vm) {
    let res = [];
    httpUtil.ajaxGet(vm, api.signal.list, job.listAllParams, function (response) {
        response.data.data.content.forEach(item => {
            res.push({
                signalId: item.signalSettingId,
                signalName: item.signalSettingName,
            });
        });
    });
    return res;
}

// 周期列表
job.getCycleList = function (vm) {
    let res = [];
    httpUtil.ajaxGet(vm, api.cycle.list, job.listAllParams, function (response) {
        response.data.data.content.forEach(item => {
            res.push({
                cycleId: item.cycleId,
                cycleName: item.cycleName,
            });
        });
    });
    return res;
}

// 设备列表
job.getEquipList = function (vm) {
    let res = [];
    httpUtil.ajaxGet(vm, api.equipment.list, job.listAllParams, function (response) {
        response.data.data.content.forEach(item => {
            res.push({
                equipId: item.equipId,
                equipName: item.equipName,
            });
        });
    });
    return res;
}

// 设备列表
job.getEquipListFunc = function (vm,suc) {
    let res = [];
    httpUtil.ajaxGet(vm, api.equipment.list, job.listAllParams, function (response) {
        response.data.data.content.forEach(item => {
            res.push({
                equipId: item.equipId,
                equipName: item.equipName,
            });
        });
        suc(res);
    });
    return res;
}

// 根据工序获取设备列表
job.getEquipListByProcessId = function(vm,id,suc){
    let res = [];
    var url = api.equipment.findbyprocess + id;
    httpUtil.ajaxGet(vm,url, {}, function (response) {
        response.data.data.forEach(item => {
            res.push({
                equipId: item.equipId,
                equipName: item.equipName,
                equipCode: item.equipCode,
            });
        });
        suc(res);
    });
    return res;
}

// 设备类型列表
job.getEquipTypeList = function (vm) {
    let res = [];
    httpUtil.ajaxGet(vm, api.equipmentType.list, job.listAllParams, function (response) {
        response.data.data.content.forEach(item => {
            res.push({
                equipmentTypeId: item.equipmentTypeId,
                equipmentTypeName: item.equipmentTypeName,
            });
        });
    });
    return res;
}

// 点检列表
job.getCheckList = function (vm,type) {
    let res = [];
    var url = api.check.list + "?checkChange=" + type;
    httpUtil.ajaxGet(vm,url , job.listAllParams, function (response) {
        response.data.data.content.forEach(item => {
            res.push({
                checkId: item.checkId,
                groupName: item.groupName,
            });
        });
    });
    return res;
}

// 设备部位
job.getPartList = function (vm) {
    let res = [];
    httpUtil.ajaxGet(vm, api.equipmentPart.list, job.listAllParams, function (response) {
        response.data.data.content.forEach(item => {
            res.push({
                partId: item.equipmentPartId,
                partName: item.equipmentPartName,
            });
        });
    });
    return res;
}

// 点检组列表
job.getCheckGroupList = function (vm) {
    let res = [];
    httpUtil.ajaxGet(vm, api.checkGroup.list, job.listAllParams, function (response) {
        response.data.data.content.forEach(item => {
            res.push({
                groupId: item.groupId,
                groupName: item.groupName,
            });
        });
    });
    return res;
}

// 故障列表
job.getTroubleList = function (vm) {
    let res = [];
    httpUtil.ajaxGet(vm, api.trouble.list, job.listAllParams, function (response) {
        response.data.data.content.forEach(item => {
            res.push({
                troubleId: item.troubleId,
                troubleCode: item.troubleCode,
                troubleName: item.troubleName,
            });
        });
    });
    return res;
}

// 车间列表
job.listPlant = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.getPlantList, {}, function (response) {
		response.data.data.forEach(item => {
			res.push({
				plantId: item.id,
				plant: item.code,
				plantNm: item.codeNm,
			});
		});
	});
	return res;
}

// 规格列表
job.listPacking = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.getPackingList, {}, function (response) {
		response.data.data.forEach(item => {
			res.push({
				packingId: item.id,
				packing: item.code,
				packingNm: item.codeNm,
			});
		});
	});
	return res;
}

// 税别列表
job.listTax = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.getTaxList, {}, function (response) {
		response.data.data.forEach(item => {
			res.push({
				taxId: item.id,
				tax: item.code,
				taxNm: item.codeNm,
			});
		});
	});
	return res;
}

// 包装袋列表
job.listPackingBag = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.getPackingBagList, {}, function (response) {
		response.data.data.forEach(item => {
			res.push({
				packingBagId: item.id,
				packingBag: item.code,
				packingBagNm: item.codeNm,
			});
		});
	});
	return res;
}

// 托盘列表
job.listPallet = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.getPalletList, {}, function (response) {
		response.data.data.forEach(item => {
			res.push({
				palletId: item.id,
				pallet: item.code,
				palletNm: item.codeNm,
			});
		});
	});
	return res;
}


export default job;



// WEBPACK FOOTER //
// ./src/utils/job.js